const module_image_url = {
    "D101": require('../../assets/cajas_herramientas/01_tecnicas_lectura.png'),
    "D102": require('../../assets/cajas_herramientas/04_tecnicas_escritura.png'),
    "D103": require('../../assets/cajas_herramientas/05_tecnicas_oralidad.png'),
    "D104": require('../../assets/cajas_herramientas/07_manejo_tiempo.png'),
    "D105": require('../../assets/cajas_herramientas/02_metodos_estudio_1.png'),
    "D106": require('../../assets/cajas_herramientas/03_orientacion_vocacional.png'),
    "D107": require('../../assets/cajas_herramientas/06_manejo_emociones.png'),
    "D201": require('../../assets/cajas_herramientas/15_educacion_financiera.png'),
    "D202": require('../../assets/cajas_herramientas/16_becas_subsidios.png'),
    "D203": require('../../assets/cajas_herramientas/17_empleo.png'),
    "D301": require('../../assets/cajas_herramientas/14_vida_familiar.png'),
    "D401": require('../../assets/cajas_herramientas/08_memoria_experiencia.png'),
    "D402": require('../../assets/cajas_herramientas/10_proyecto_vida.png'),
    "D403": require('../../assets/cajas_herramientas/11_auto_conocimiento.png'),
    "D404": require('../../assets/cajas_herramientas/12_salud_mental.png'),
    "D405": require('../../assets/cajas_herramientas/09_redes_apoyo.png'),
    "D406": require('../../assets/cajas_herramientas/13_pares_acompañan.png'),
    "D501": require('../../assets/cajas_herramientas/19_conociendo_u.png'),
    "D502": require('../../assets/cajas_herramientas/22_conociendo_ases.png'),
    "D503": require('../../assets/cajas_herramientas/21_servicios_universitarios.png'),
    "D504": require('../../assets/cajas_herramientas/18_oferta_bienestar.png'),
    "D505": require('../../assets/cajas_herramientas/20_grupos_investigacion.png'),
    "OBJETO_1": require('../../assets/objeto_01.png'),
    "OBJETO_2": require('../../assets/objeto_02.png'),
  };
  
  export default module_image_url;
  